import React from "react";
import PropTypes from 'prop-types';
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { BeatLoader } from 'react-spinners';
import 'braintree-web';
import DropIn from 'braintree-web-drop-in-react';
import paymentService from "../../../services/paymentService";

export default class PlanPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientToken: null,
      nonce: '',
      loading: true,
      planId: this.props.planId,
      plans: this.props.plans,
      selectedPlan: {},
      submited: true
    };
    this.handleNounce = this.handleNounce.bind(this);
  }

  async componentDidMount() {
    this.generateBrainTreeToken()
    this.getPlanName(this.state.planId)
  }

  generateBrainTreeToken() {
    paymentService.generateToken().then(response => {
      this.setState({ clientToken: response, loading: false });
    }).catch(error => {
      toast.error(error.response, this.options)
    })
  }
  async handleNounce() {
    const { nonce } = await this.instance.requestPaymentMethod();
    this.setState({
      nonce: nonce
    })
    await this.callSubmit(this.state)
  }

  async callSubmit(data) {
    this.setState({
      submited: false,
      loading: true
    })
    let payment = await this.props.handleSubmitPayment(this.state);
    if (payment) {
      this.setState({
        loading: false
      })
    }
  }

  getPlanName(planId) {
    let plans = this.state.plans;
    if (plans.length > 0) {
      let plan = plans.filter(element => {
        return element.id === planId
      })
      this.setState({
        selectedPlan: plan
      })
    }
  }

  render() {
    const { clientToken, selectedPlan, submited } = this.state;
    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.handleClose} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Purchase plan</Modal.Title>
          </Modal.Header>
          {this.state.loading ?
            <div className=" m-5 text-center">
              <BeatLoader
                // css={override}
                sizeUnit={"px"}
                size={15}
                color={'#299bff'}
                loading={this.state.loading}
              />
            </div> : null}
          {clientToken ?
            <div>
              <Modal.Body className="purchase-body">
                <div>
                  <ul className="selected-plan-modal">
                    <li>Selected plan: <span>{selectedPlan[0].name}</span></li>
                    <li>Price: <span>$ {selectedPlan[0].price}</span></li>
                  </ul>
                </div>
                {submited ?
                  <div>
                    <DropIn
                      options={{ authorization: this.state.clientToken }}
                      onInstance={instance => (this.instance = instance)}
                    />
                  </div> : null}
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-lightblue"
                  onClick={this.handleNounce}
                >
                  Buy now
            </button>
                <button className="btn btn-lightblue" onClick={this.props.handleClose}>
                  Close
            </button>
              </Modal.Footer>
            </div> : null}
        </Modal>
      </div >
    );
  }
}

PlanPayment.propTypes = {
  organization: PropTypes.object,
  handleSubmitPayment: PropTypes.func,
  handleClose: PropTypes.func,
  show: PropTypes.bool,
  plans: PropTypes.array,
  planId: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/planComponent/modals/payment.js